<template>
  <div>
    <div id="mapContainer" style="height: 70vh !important"></div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-gpx/gpx.js";
import "leaflet/dist/images/marker-shadow.png";
import L from "leaflet";
import * as turf from "@turf/turf";
import { parse } from "qs";
export default {
  components: {},
  props: {
    coureurs: {
      default: [],
    },
    list_lines: {
      default: [],
    },
    selected_parcours: {
      default: [],
    },
    focus_point: {
      default: [],
    },
    selected_mode: {
      default: "",
    },
  },
  data() {
    return {
      map: {},
      list_marker_points: [],
      focus_marker: {},
      icons: [],
      fond_carte: {},
      colors: ["#8d0801", "#04395e", "#084c61", "#6f2dbd", "#ff6700"],
    };
  },
  watch: {
    selected_mode: function (newVal, oldVal) {
      this.fond_carte.setUrl(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link);
    },
    focus_point: function (newVal, oldVal) {
      // watch it
      if (Object.keys(this.focus_marker).length === 0) {
        var options = {
          units: "kilometers",
        };
        var point_coordinates = turf.along(this.line, this.focus_point, options);

        this.focus_marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
          title: "focus",
          icon: this.icons["focus"],
        });
        this.focus_marker.addTo(this.map);
      } else {
        if (this.focus_point === 0) {
          this.map.removeLayer(this.focus_marker);
          this.focus_marker = {};
        } else {
          var point_coordinates = turf.along(this.line, this.focus_point, options);
          this.focus_marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
        }
      }
    },
    coureurs: function (newVal, oldVal) {
      for (var i = 0; i < oldVal.length; i++) {
        if (oldVal[i].marker) {
          this.map.removeLayer(oldVal[i].marker);
        }
      }
      if (newVal.length > 0) {
        this.defineMarkers();
        this.displayCoureurs();
      }
      this.$forceUpdate();
    },
    list_lines: function (newVal, oldVal) {
      this.list_parcours = JSON.parse(JSON.stringify(this.selected_parcours));
      this.initLines();
      this.displayPoints();
      this.defineMarkers();
      this.displayCoureurs();
    },
  },

  methods: {
    defineMarkers: function () {
      for (var i = 0; i < this.coureurs.length; i++) {
        let point_coordinates = this.getPointCoordinatesGivenParcours(this.coureurs[i].course, 0);
        let marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
          title: this.coureurs[i].dossard,
          icon: new L.DivIcon({
            className: "coureur-icon",
            html:
              "<div class='pin_runner_profil_container_map'><img class='pin_runner_profil_map' src='https://sportips.fr/live/includes/img/pin-runner-2.png'/><span class='pin_runner_content_map'>" +
              this.coureurs[i].nom.charAt(0).toUpperCase() +
              this.coureurs[i].prenom.charAt(0).toUpperCase() +
              "</span></div>",
            iconAnchor: [17, 40],
          }),
        });

        marker.addTo(this.map);
        this.coureurs[i].marker = marker;
      }
    },
    getPointCoordinatesGivenParcours(course, distance) {
      var options = {
        units: "kilometers",
      };
      for (let i = 0; i < this.list_parcours.length; i++) {
        if (this.list_parcours[i].nom == course) {
          return turf.along(this.list_parcours[i].line, parseFloat(distance), options);
        }
      }
      return turf.along(this.list_parcours[0].line, parseFloat(0), options);
    },
    displayCoureurs: function () {
      var options = {
        units: "kilometers",
      };
      for (var i = 0; i < this.coureurs.length; i++) {
        let point_coordinates;
        if (!this.coureurs[i].statut.depart || !this.coureurs[i].statut.course_start) {
          point_coordinates = this.getPointCoordinatesGivenParcours(this.coureurs[i].course, 0);
          this.coureurs[i].marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
        } else if (this.coureurs[i].statut.arrivee || this.coureurs[i].statut.course_end) {
          point_coordinates = this.getPointCoordinatesGivenParcours(this.coureurs[i].course, 1000);
          this.coureurs[i].marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
        } else {
          if (this.coureurs[i].tracking_methode === "estimation") {
            if (this.coureurs[i].estimation.distance) {
              if (this.coureurs[i].estimation.distance < 0) {
                this.coureurs[i].estimation.distance = 0;
              }
              point_coordinates = this.getPointCoordinatesGivenParcours(this.coureurs[i].course, this.coureurs[i].estimation.distance);
              this.coureurs[i].marker.setLatLng([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]]);
            }
          } else {
            let position = JSON.parse(JSON.stringify([this.coureurs[i].position[0], this.coureurs[i].position[1]]));
            this.coureurs[i].marker.setLatLng(position);
          }
        }
      }
    },
    displayPoints: function () {
      for (var i = 0; i < this.list_marker_points.length; i++) {
        this.map.removeLayer(this.list_marker_points[i]);
      }
      this.list_marker_points = [];
      var options = {
        units: "kilometers",
      };
      for (let i = 0; i < this.list_parcours.length; i++) {
        if (this.list_parcours[i].points && this.list_parcours[i].line) {
          for (let j = 0; j < this.list_parcours[i].points.length; j++) {
            let current_point = this.list_parcours[i].points[j];

            if (!this.list_parcours[i].line) {
              break;
            }
            let point_coordinates = turf.along(this.list_parcours[i].line, parseFloat(current_point.distance_depuis_depart), options);
            var marker = new L.marker([point_coordinates.geometry.coordinates[1], point_coordinates.geometry.coordinates[0]], {
              title: current_point.nom_affiche,
              icon: this.icons["point"],
            });
            this.list_marker_points.push(marker);
            marker.addTo(this.map);
          }
        }
      }
    },

    initMap() {
      var _this = this;
      this.map = L.map("mapContainer", {
        zoomControl: false,
      });

      let max_dist = 0;
      for (let i = 0; i < this.list_parcours.length; i++) {
        if (this.list_parcours[i].centre_trace.length > 0) {
          this.map.setView(this.list_parcours[i].centre_trace, 13);
        }
        this.gpx = new L.GPX(this.list_parcours[i].trace, {
          polyline_options: {
            color: _this.colors[i % _this.colors.length],
            opacity: 0.9,
            weight: 4,
            lineCap: "round",
          },
          async: true,
          marker_options: {
            wptIconUrls: {
              "": "https://sportips.fr/live/includes/img/wp.png",
            },
            startIconUrl: "https://sportips.fr/live/includes/img/pin-start.png",
            endIconUrl: "https://sportips.fr/live/includes/img/pin-end.png",
          },
        })
          .on("loaded", function (e) {
            _this.map.fitBounds(e.target.getBounds());
          })
          .addTo(this.map);
      }
      this.fond_carte = L.tileLayer(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link, {
        zoomControl: false,
        maxZoom: 17,
        attribution:
          'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
      }).addTo(this.map);
    },

    initLines() {
      for (let i = 0; i < this.list_lines.length; i++) {
        for (let j = 0; j < this.list_parcours.length; j++) {
          if (this.list_lines[i].parcours_id == this.list_parcours[j].id) {
            this.list_parcours[j].line = turf.lineString(this.list_lines[i].lines);
          }
        }
      }
    },

    setIcons: function () {
      this.icons["coureur"] = L.divIcon({
        className: "custom-div-icon",
        html: "<div style='background-color:#c30b82;' class='marker-pin'></div><i class='material-icons'>weekend</i>",
        iconSize: [24, 37],
        iconAnchor: [12, 37],
      });
      this.icons["focus"] = L.icon({
        iconUrl: "https://sportips.fr/live/includes/img/focus_point.png",
        iconSize: [15, 15],
        iconAnchor: [7, 7],
      });
      this.icons["point"] = L.icon({
        iconUrl: "https://sportips.fr/live/includes/img/pin-checkpoint-before.png",
        iconSize: [24, 37],
        iconAnchor: [12, 37],
      });
    },
  },
  mounted() {
    this.list_parcours = JSON.parse(JSON.stringify(this.selected_parcours));
    this.setIcons();
    this.initMap();
    this.initLines();
    this.displayPoints();
    this.defineMarkers();
    this.displayCoureurs();
  },
};
</script>

<style>
#mapContainerLive {
  width: 100% !important;
  height: 80vh !important;
  min-height: 300px;
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
  box-shadow: rgb(33 35 38 / 10%) 0px 10px 10px -10px !important;
  border: 1px solid #dbe0e6 !important;
  border-bottom: none !important;
}

.custom-marker-pin {
  padding: 5px;
  border: 1px solid #f29200;
}
</style>
